import { replaceApexDomainForCurrentHost } from './replace-apex-domain-for-current-host';

export const API_HOST = replaceApexDomainForCurrentHost(import.meta.env.VITE_API_HOST);
export const METRICS_HOST = replaceApexDomainForCurrentHost(import.meta.env.VITE_METRICS_API_HOST);
export const GREENROOM_HOST = replaceApexDomainForCurrentHost(import.meta.env.VITE_GREENROOM_API);
// Live monitor is only deployed at live-monitor.brandlive[-env].com
export const LIVE_MONITOR_HOST = import.meta.env.VITE_LIVE_MONITOR_HOST;
